// Las curvas punteadas entre la prenda y cada parte de la mezcla que se está armando
// (ADR-2026-09-17-las-partes-se-atan-con-una-linea, ADR-2026-09-17-las-lineas-salen-en-curva):
// salen en horizontal del costado de la prenda. Va por la ranura `Capa` del lienzo,
// adentro de React Flow: `ViewportPortal` la dibuja en las coordenadas de los nodos, así
// acompaña el zoom y el paneo sin calcular nada; los nodos traen su posición y su tamaño
// (`style`, el del acomodo) y la geometría la resuelve `lineasDeMezcla`, que es pura.
// `pointer-events: none`: la capa no se toca, el lienzo sigue tocable debajo.

import { ViewportPortal, useNodes } from '@xyflow/react';
import { useDiseno } from './disenoContext';
import { lineasDeMezcla, type NodoMedido } from './geometriaDeMezcla';

const medida = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0);

export const LineasDeMezcla: React.FC = () => {
  const d = useDiseno();
  const nodos = useNodes();
  const mezcla = d.mezcla;
  if (!mezcla || mezcla.partes.length === 0) return null;
  const medidos: NodoMedido[] = nodos.map((n) => ({
    id: n.id,
    x: n.position.x,
    y: n.position.y,
    ancho: medida(n.measured?.width ?? n.style?.width),
    alto: medida(n.measured?.height ?? n.style?.height),
  }));
  const lineas = lineasDeMezcla(medidos, mezcla.baseId, mezcla.partes.map((p) => p.celdaId));
  if (lineas.length === 0) return null;
  return (
    <ViewportPortal>
      <svg className="pointer-events-none absolute left-0 top-0 overflow-visible" width={1} height={1} aria-hidden="true">
        {lineas.map((l) => (
          <path
            key={l.id}
            className="lienzo-linea-de-mezcla"
            d={l.d}
            fill="none"
            style={{ stroke: 'var(--brand-primary)' }}
            strokeOpacity={0.55}
            strokeWidth={1.75}
            strokeLinecap="round"
          />
        ))}
      </svg>
    </ViewportPortal>
  );
};
